import { render, staticRenderFns } from "./SalesforceConfig.vue?vue&type=template&id=844437ee&scoped=true&"
import script from "./SalesforceConfig.vue?vue&type=script&lang=js&"
export * from "./SalesforceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844437ee",
  null
  
)

export default component.exports